import _isEmpty from 'lodash/isEmpty';

import { selectWebsiteContentNodes } from '../../../selectors/website';

export function shouldDisplayContentPage(state) {
  const nodes = selectWebsiteContentNodes(state);

  return !_isEmpty(nodes);
}
